import React, {useEffect, useState} from 'react';
import {Button, Input} from "@chatui/core";

function Integer(props) {
    const editable = props.editable!==undefined? props.editable: true;
    const value = props.value;
    const setValue = props.setValue;
    const [addDisable, setAddDisable] = useState(false);
    const [minusDisable, setMinusDisable] = useState(false);
    const maximum = props.maximum!==undefined? props.maximum: 999999;
    const minimum = props.minimum!==undefined? props.minimum: -999999;

    const add = ()=>{
        setValue(value+1);
    };

    const minus = () => {
        setValue(value-1)
    };

    const change = (val) => {
        if (val === '') {
            // 当输入为空时，设置为空字符串
            setValue('');
            return;
        }
        
        const numVal = Number(val);
        if (!isNaN(numVal)) {
            // 当输入为有效数字时，设置为数字类型
            setValue(numVal);
        } else {
            // 当输入为无效数字时，保持当前值不变
            // 可以选择保持原值或设置为空
            return;
        }
    }

    useEffect(() => {
        if (value === undefined || value === null || value === '') {
            // 当值不存在或为空时，保持为空状态
            return;
        }
        
        const numValue = Number(value);
        if (isNaN(numValue)) {
            // 如果值不是数字，也保持为空状态
            return;
        }
        
        if (numValue >= maximum) {
            setValue(maximum);
            setAddDisable(true);
        }
        else if (numValue <= minimum){
            setValue(minimum);
            setMinusDisable(true);
        }
        else{
            setMinusDisable(false);
            setAddDisable(false);
        }
    }, [value, maximum, minimum, setValue]);

    return (
        <div>

            <Button
                disabled={minusDisable}
                color={'primary'}
                icon={'minus'}
                onClick={minus}
            ></Button>

            {editable? (
                <Input value={value === undefined || value === null ? '' : value.toString()}
                    onChange={val=>change(val)}
                ></Input>
            ):
                <span
                    className={"int-value"}
                >{value}</span>
            }


            <Button
                disabled={addDisable}
                color={'primary'}
                icon={'plus'}
                onClick={add}
            ></Button>

        </div>
    );
}

export default Integer;